const en = {
  common: {
    remove: "Remove",
    portal: "Portal",
    role: "Role",
    quantity: "Quantity",
    amount: "Amount",
    date: "Date",
    label: "Label",
    change: "Change",
    campaignName: "Campaign Name",
    createdBy: "Created By",
    method: "Method",
    openingDate: "Opening Date",
    closingDate: "Closing Date",
    production: "Production",
    packing: "Packing",
    payments: "Payments",
    totalOrders: "Total Orders",
    totalRevenue: "Total Revenue",
    activeCampaigns: "Active Campaigns",
    totalMembers: "Total Members",
    buyerName: "Buyer Name",
    totalPrice: "Total Price",
    orderId: "Order ID",
    customer: "Customer",
    order: "Order",
    appName: 'Cheeco',
    english: 'English',
    language: 'Language',
    languageDescription: 'Choose the display language for this browser.',
    languageSaved: 'Language preference updated.',
    save: 'Save',
    saving: 'Saving...',
    saveSettings: 'Save Settings',
    cancel: 'Cancel',
    processing: 'Processing...',
    reject: 'Reject',
    confirm: 'Confirm',
    delete: 'Delete',
    deleting: 'Deleting...',
    deleteRecord: 'Delete Record',
    deleteRecordConfirmation: 'Are you sure you want to delete this record? This action cannot be easily undone.',
    closeNotification: 'Close notification',
    savedSuccessfully: 'Record saved successfully.',
    requiredWarning: 'Please complete all required fields.',
    saveError: 'Unable to save record. Please try again.',
    importSuccess: 'CSV import completed successfully.',
    backToDashboard: 'Back to Dashboard',
    backToLogin: 'Back to Login',
    continueToLogin: 'Continue to Login',
    loading: 'Loading...',
    search: 'Search',
    all: 'All',
    status: 'Status',
    actions: 'Actions',
    name: 'Name',
    class: 'Class',
    age: 'Age',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    product: 'Product',
    products: 'Products',
    campaign: 'Campaign',
    campaigns: 'Campaigns',
    staff: 'Staff',
    vendors: 'Vendors',
    order: 'Order',
    orders: 'Orders',
    member: 'Member',
    members: 'Members',
    settings: 'Settings',
    reports: 'Reports',
    roles: 'Roles',
    dashboard: 'Dashboard',
    invoice: 'Invoice',
    printPdf: 'Print PDF',
    downloadPdf: 'Download PDF',
    printInvoice: 'Print Invoice',
    downloadInvoice: 'Download Invoice',
    paymentStatus: 'Payment Status',
    paymentMethod: 'Payment Method',
    paid: 'Paid',
    pending: 'Pending',
    failed: 'Failed',
    approved: 'Approved',
    rejected: 'Rejected',
    draft: 'Draft',
    closed: 'Closed',
    open: 'Open',
    noResults: 'No results found.',
    noSettings: 'No settings available.',
    unableToLoad: 'Unable to load data.',
    unableToSave: 'Unable to save changes.',
    updated: 'Changes updated successfully.',
    sessionExpired: 'Session expired. Please sign in again.',
    accessDenied: 'Access denied.',
    forbiddenPermission: 'Access denied: you do not have the required permission.',
    selectFileFirst: 'Please select a file first.',
    chooseLanguage: 'Choose language',
    myProfile: 'My Profile',
    openNavigation: 'Open navigation',
    logout: 'Logout',
    user: 'User',
    currentUser: 'Current User',
    organizationNavigation: 'Organization navigation',
    organizationLabel: 'Organization',
    categories: 'Categories',
    inventory: 'Inventory',
    paymentCenter: 'Payment Center',
    pendingApprovals: 'Pending Approvals',
    viewAll: 'View All',
    storeApprovals: 'Store Approvals',
    campaignReviews: 'Campaign Reviews',
    memberReports: 'Member Reports',
    bids: 'Bids',
    activityLogs: 'Activity Logs',
    printLabels: 'Print Labels',
    platformProducts: 'Platform Products',
    registerOrganization: 'Register Organization',
    registerSchool: 'Register School',
    claimOrganization: 'Claim Your Organization',
    signIn: 'Sign In',
    organizationPortal: 'Organization Portal',
    schoolPortal: 'School Portal',
    parentPortal: 'Parent Portal',
    vendorPortal: 'Vendor Portal',
    platformPortal: 'Platform Portal',
    yes: 'Yes',
    no: 'No',
    bag: 'Bag',
    profile: 'Profile',
    searchAnything: 'Search anything...',
    superAdmin: 'Super Admin',
    memberStudent: 'Student',
    memberGeneric: 'Member',
    administrator: 'Administrator',
    principal: 'Principal',
    president: 'President',
    company: 'Company',
    employee: 'Employee',
    manager: 'Manager',
    business: 'Business',
    owner: 'Owner',
    volunteer: 'Volunteer',
    coordinator: 'Coordinator',
    statusLabels: {
    submitted: "Submitted",
    published: "Published",
    open: "Open",
      draft: 'Draft',
      rfq_open: 'RFQ Open',
      closed: 'Closed',
      pending: 'Pending',
      pending_setup: 'Pending Setup',
      active: 'Active',
      disabled: 'Disabled',
      suspended: 'Suspended',
      awarded: 'Awarded',
      not_awarded: 'Not Awarded',
      production: 'Production',
      packaging: 'Packaging',
      packing: 'Packaging',
      delivery: 'Delivery',
      ready_for_delivery: 'Ready for Delivery',
      delivered: 'Delivered',
      completed: 'Completed',
      cancelled: 'Cancelled',
      archived: 'Archived',
      paid: 'Paid',
      paid_online: 'Paid Online',
      organization_paid: 'Organization Paid',
      manual_verified: 'Manually Verified',
      awaiting_approval: 'Awaiting Approval',
      failed: 'Failed',
      refunded: 'Refunded',
      super_admin: 'Super Admin',
      platform_admin: 'Platform Admin',
      tenant_admin: 'Admin',
      buyer: 'Buyer',
      vendor: 'Vendor',
      independent_seller: 'Independent Seller',
      school: 'School',
      pending_approval: 'Pending Approval',
      requested_info: 'Info Requested',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    action: 'Action',
    active: 'Active',
    close: 'Close',
    description: 'Description',
    edit: 'Edit',
    inactive: 'Inactive',
    independentPortal: 'Independent Portal',
    next: 'Next',
    of: 'of',
    organizationAdminLogin: 'Organization Admin Login',
    organizations: 'Organizations',
    previous: 'Previous',
    showing: 'Showing',
    size: 'Size',
    stock: 'Stock',
    to: 'to',
    unknown: 'unknown',
    workspace: 'Workspace',
    back: 'Back',
    continue: 'Continue',
    parent: 'Parent',
    school: 'School',
  },
  auth: {
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    sendResetLink: 'Send Reset Link',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    emailAddress: 'Email Address',
    tokenMissing: 'Reset token is missing. Please request a new password reset link.',
    resetSuccess: 'Password updated successfully. Please sign in again.',
    resetFailed: 'Unable to reset password.',
    resetLinkSent: 'If an account with that email exists, we\'ve sent a password reset link.',
    resetLinkFailed: 'Unable to send the reset link. Please try again.',
    loginFailed: 'Login failed. Please check your details.',
    parentPortalRequired: 'Parent accounts must sign in through the Parent Portal.',
    serverUnavailable: 'Unable to connect to the server. Please check the domain or API and try again.',
    emailVerified: 'Email Verified',
    emailVerifiedDescription: 'Your email address has been verified successfully.',
    verificationProcessed: 'Your verification request has been processed.',
    verificationContinue: 'You can now continue using Cheeco with this email address.',
    signIn: 'Sign in',
    emailRequired: 'Email is required',
    enterValidEmail: 'Please enter a valid email address',
    enterYourEmail: 'Enter your email',
    emailPlaceholder: 'your@email.com',
    checkYourEmail: 'Check Your Email',
    magicLinkSent: 'Magic Link Sent',
    weSentMagicLinkTo: 'We sent a magic link to',
    weSentNewMagicLinkTo: 'We sent a new magic link to',
    checkYourInbox: 'Please check your inbox.',
    linkExpiresIn10: 'The link expires in 10 minutes and can only be used once.',
    requestAnotherLinkIn: 'You can request another link in',
    minutes: 'minutes',
    sendingMagicLink: 'Sending magic link',
    resendMagicLink: 'Resend magic link',
    sending: 'Sending...',
    didntReceive: 'Didn\'t receive it? Click to resend',
    useDifferentEmail: 'Use a different email',
    useDifferentEmailTitle: 'Use Different Email',
    emailAlreadyRegistered: 'This email is already registered',
    noPasswordNeeded: 'No password needed. We\'ll send you a secure magic link.',
    passwordlessCommerce: 'Passwordless School Commerce',
    passwordlessCommerceTagline: 'Cheeco — Passwordless School Commerce',
    welcomeToCheeco: 'Welcome to Cheeco',
    tellUsWhoYouAre: 'Tell us who you are, then enter your email to continue.',
    iAmRegisteringAs: 'I am registering as',
    continueWithEmail: 'Continue with email',
    backToHome: 'Back to Home',
    requestTooLong: 'The request is taking too long. Please check your connection and try again.',
    couldNotReach: 'We could not reach Cheeco. Please check your internet connection and try again.',
    tooManyAttempts: 'Too many attempts. Please wait a few minutes and try again.',
    checkEmailEntered: 'Please check the email you entered and try again.',
    serverUnavailableShort: 'Our server is temporarily unavailable. Please try again in a few minutes. If the problem continues, contact support@cheeco.com.',
    unexpectedError: 'Something unexpected happened. Please try again.',
    enterEmailAddress: 'Please enter your email address.',
    enterValidEmailWithExample: 'Please enter a valid email address (e.g. name@domain.com).',
    tooManyWait: 'Too many attempts. Please wait before requesting another link.',
    failedToSend: 'Failed to send magic link. Please try again.',
    retryIn: 'Retry in',
    wait: 'Wait',
    sendMeNewLink: 'Send me a new Magic Link',
    linkExpired: 'Link Expired',
    linkExpiredDescription: 'This magic link has expired. For security, links are only valid for 10 minutes. Please request a new one.',
    linkAlreadyUsed: 'Link Already Used',
    linkAlreadyUsedDescription: 'This magic link has already been used. Each link can only be used once for security. Please request a new one.',
    invalidLink: 'Invalid Link',
    invalidLinkDescription: 'This link appears to be invalid or malformed. Please request a new magic link.',
    tokenNotFound: 'Token Not Found',
    tokenNotFoundDescription: 'The magic link token was not found. It may have already been consumed or deleted. Please request a new one.',
    noLinkFound: 'No Link Found',
    noLinkFoundDescription: 'No authentication token was found in the URL. Please request a new magic link.',
    networkError: 'Network Error',
    networkErrorDescription: 'We could not reach the server to verify your link. This is often caused by a stale service worker. Please hard-refresh (Ctrl+Shift+R) and try again.',
    requestTimeoutTitle: 'Request Timeout',
    requestTimeoutDescription: 'The verification request timed out. Please try again.',
    connectionError: 'Connection Error',
    connectionErrorDescription: 'We couldn\'t verify your link because you appear to be offline. Please check your connection and try again.',
    tooManyRequests: 'Too Many Requests',
    tooManyRequestsDescription: 'Too many verification attempts. Please wait a few minutes before trying again.',
    serverError: 'Server Error',
    serverErrorDescription: 'Our server encountered an error while verifying your link. Please try again in a few minutes. If the problem continues, contact support.',
    linkInvalidOrExpired: 'Link Invalid or Expired',
    linkInvalidOrExpiredDescription: 'This magic link is invalid, expired, or has already been used. Please request a new one.',
    needHelpContact: 'Need help? Contact your school administrator or',
    needHelpFull: 'Need help? Contact your school administrator or Cheeco support.',
    cheecoSupport: 'Cheeco support',
    noTokenProvided: 'No authentication token was provided. Please request a new magic link.',
    malformedLink: 'This link appears to be malformed. Please request a new magic link.',
    verificationFailed: 'Verification failed. Please try again.',
    multipleRetryFailed: 'Multiple retry attempts failed. Please request a new magic link.',
    verifyingYourLink: 'Verifying your link...',
    pleaseWaitVerify: 'Please wait while we verify your magic link.',
    thisMayTakeSeconds: 'This may take a few seconds',
    loginSuccessful: 'Login Successful',
    redirectingToDashboard: 'Redirecting you to your dashboard...',
    magicLinksExpire: 'Magic links expire after 10 minutes for security. Please request a new one.',
    linkAlreadyUsed2: 'This link has already been used. Each magic link can only be used once.',
    multipleAttemptsFailed: 'Multiple attempts failed. This may be due to a network issue or the link has expired.',
    tryAgain: 'Try Again',
    requestNewLink: 'Request New Link',
    verifyingSecureLink: 'Verifying secure link...',
    signingYouIn: 'Signing you in...',
    redirecting: 'Redirecting...',
    organisationAccess: 'Organisation access',
    organisationAdminLogin: 'Organisation Admin Login',
    organisationSuperAdminLogin: 'Organisation Super Admin Login',
    organisationMemberUser: 'Organisation Member / User',
  },
  orders: {
    title: 'Orders',
    listTitle: 'Order List and Manual Order Form',
    description: 'Organization admins can create manual orders when buyers need help using the system.',
    myOrders: 'My Orders',
    buyer: 'Buyer',
    size: 'Size',
    quantity: 'Quantity',
    amount: 'Amount',
    type: 'Type',
    completed: 'Completed',
    pay: 'Pay',
    manualOrder: 'Manual Order',
    addManualOrder: 'Add Manual Order',
    selectProduct: 'Select Organization Product',
    noActiveProducts: 'No active products are available for this organization.',
    paymentPending: 'Unpaid (Pending)',
    paymentPaidCash: 'Paid (Cash)',
    paymentDeposit: 'Partial Payment (Deposit)',
    submitOrder: 'Submit Order',
    submitting: 'Submitting...',
    pdfLabelsFailed: 'Unable to generate PDF labels.',
    labelsReady: '{{count}} labels are ready for printing.',
    onlineBuyer: 'Buyer Online',
    adminManual: 'Admin Manual',
    noOrders: 'No orders found.',
    noMatchingOrders: 'No matching orders found.',
    searchPlaceholder: 'Search order, buyer, class, size, amount',
  },
  parent: {
    school: 'Schools',
    familyDashboardFailed: 'Unable to load the family dashboard.',
    memberAdded: 'Member added successfully.',
    duplicateMerged: 'Duplicate member merged successfully.',
    memberAddFailed: 'Unable to add member.',
    profileUpdated: 'Profile updated.',
    fullName: 'Full Name',
    yourName: 'Your name',
    yourEmail: 'you@example.com',
    phoneNumber: 'Phone number',
    yourAddress: 'Your address',
    languageUpdated: 'Language updated.',
    saveChanges: 'Save Changes',
    manageFamily: 'Manage Family Members',
    noFamilyMembers: 'No family members added yet.',
    addFamilyMember: 'Add Family Member',
    relationship: 'Relationship',
    memberName: 'Member Name',
    enterName: 'Enter name',
    classPlaceholder: 'e.g. 5 Aman',
    adding: 'Adding...',
    myKids: 'My Kids',
    addStudent: 'Add Student',
    addStudentDescription: 'Add your child\'s information.',
    studentName: 'Student Name',
    studentNamePlaceholder: 'e.g. Ahmad Hakimi',
    classLabel: 'Class',
    classPlaceholderStudent: 'e.g. 3 Amanah',
    sportsHouse: 'Sports House',
    selectSportsHouse: 'Select Sports House',
    mySchools: 'My Schools',
    students: 'Students',
    manage: 'Manage',
    connectSchool: 'Connect Another School',
    edit: 'Edit',
    noOrganizationProducts: 'This organization does not have products available for ordering yet.',
    productNotFound: 'Organization product was not found for ordering.',
    organization: 'Organization',
    organizationGroupsDescription: 'Each organization shows member count, active products, progress, and announcements.',
    addMemberFirst: 'Add your member first. The dashboard will then group orders by organization.',
    noActiveProductsForOrganization: 'Members are added, but the linked organization has no active products yet.',
    addMemberToSeeOrganization: 'Add a member to view organization details.',
    organizationProductsAvailable: 'Organization products available',
    noActiveProducts: 'No active products are available for this organization.',
    noProductsAvailable: 'No products are currently available. Products will appear once your Organization Administrator publishes them.',
    noOrdersTitle: 'No orders yet',
    noOrdersForMember: 'This member does not have recorded orders yet.',
    noFamilyOrders: 'No orders have been created by this account yet.',
    orderClosed: 'Orders Closed',
    memberOrders: 'Member Orders',
    viewDetails: 'View Details',
    paidComplete: 'Payment completed',
    receiptFailed: 'Unable to load receipt.',
    invoicePdfFailed: 'Unable to generate invoice PDF.',
    receiptTitle: 'Order Receipt',
    redirectingToOrder: 'Redirecting to order details in {{seconds}}s...',
    checkoutAndPay: 'Checkout and Pay',
    processing: 'Processing...',
    orderSummary: 'Order Summary',
    paymentCompleteSummary: 'Payment completed. This is your order summary.',
    orderDeadlinePassed: 'Orders are closed. The product deadline has passed.',
    orderCreatedMissingId: 'Order was created, but the order ID was not found. Please check your dashboard.',
    organizationPaysSuccess: 'Organization-paid order created successfully. Status is already paid.',
    orderCreatedRedirect: 'Order created successfully. Redirecting to payment...',
    orderCreatedPay: 'Order created successfully. Please continue with payment.',
    cartAdded: 'Item added to cart.',
    cartPaid: 'Cart submitted and paid successfully.',
    cartProcessed: 'Checkout successful. All items were processed under the same cart ID.',
    orderClosedShort: 'Orders closed.',
    deadline: 'Deadline: {{value}}',
    noOrderItems: 'No order items were found for this reference.',
    backToOrders: 'Back to Order List',
    exactNameClass: 'Enter the full name and exact class. If there is no match, the system will tell you the member was not found.',
  },
  organization: {
    workspace: 'Organization Workspace',
    workspaces: 'Workspaces',
    settingsTitle: 'Organization Settings',
    settingsDescription: 'Keep your organization profile and contact details current.',
    profile: 'Organization Profile',
    profileDescription: 'Public identity and primary contact information',
    type: 'Organization Type',
    contactPerson: 'Contact Person',
    mobileNumber: 'Mobile Number',
    updated: 'Organization settings updated.',
    membersLoadFailed: 'Unable to load the member list.',
    dashboardLoadFailed: 'Unable to load the organization order summary.',
    logoUpdated: 'Organization logo updated successfully.',
    logoUploadFailed: 'Unable to upload the organization logo.',
    draftSaved: 'Draft saved successfully. You can edit it anytime.',
    draftSaveFailed: 'Unable to save the product draft.',
    productInfoMissing: 'Please complete the product information: {{fields}}.',
    productSubmitted: 'Product submitted for platform admin approval.',
    productSubmitFailed: 'Unable to submit the product for approval.',
    submissionCancelled: 'Submission cancelled. Product returned to draft status.',
    cancelSubmissionFailed: 'Unable to cancel the product submission.',
    uploadStudentsDenied: 'Access denied: you do not have permission to upload members.',
    remindersDenied: 'Access denied: you do not have permission to send reminders.',
    remindersSent: 'Reminders sent for {{count}} members.',
    remindersFailed: 'Unable to send reminders.',
    selectProductFirst: 'Please select a product first.',
    selectSpecificMembers: 'Please select at least one member for Specific mode.',
    bulkOrderSuccess: 'Bulk order completed. Created: {{created}}, Skipped: {{skipped}}.',
    bulkOrderFailed: 'Bulk order failed.',
    uploadSuccess: 'Upload Successful',
    productApprovedBuyerVisible: 'The product has been approved and is now visible to buyers.',
    draftNotSubmitted: 'Draft has not been submitted to the platform admin.',
    rejectionReason: 'Rejection reason: {{reason}}',
    noReason: 'No reason provided.',
    workspaceDashboard: 'Workspace Dashboard',
    workspaceMembers: 'Workspace Members',
    workspaceAdministrators: 'Workspace Administrators',
    workspaceReports: 'Workspace Reports',
    workspaceSettings: 'Workspace Settings',
    currentWorkspace: 'Current Workspace',
    workspaceSurfaces: 'Workspace Surfaces',
    workspaceName: 'Workspace Name',
    slug: 'Slug',
    typeLabel: 'Type',
    active: 'Active',
    workspaceLoadFailed: 'Unable to load workspace information.',
  },
  schoolAdminDashboard: {
    activeCampaigns: 'Active Campaigns',
    totalMembers: 'Total Members',
    verifiedMembers: 'Verified Members',
    pendingMembers: 'Pending Members',
    ordersReceived: 'Orders Received',
    campaignCompletion: 'Campaign Completion',
    productionProgress: 'Production Progress',
    packingProgress: 'Packing Progress',
    deliveryProgress: 'Delivery Progress',
    noActiveCampaigns: 'No active campaigns',
    createCampaign: 'Create Campaign',
    uploadRoster: 'Upload Roster',
    viewDetails: 'View Details',
    closeCampaign: 'Close Campaign',
    completionPercentage: 'Completion %',
    members: 'Members',
    orders: 'Orders',
    status: 'Status',
  },
  independent: {
    myStore: 'My Store',
    notifications: 'Notifications',
    seller: 'Seller',
  },
  nav: {
    members: "Members",
    verification: "Verification",
    myKids: 'My Kids',
    campaigns: 'Campaigns',
    orders: 'Orders',
    home: 'Home',
    shop: 'Shop',
    cart: 'Cart',
    profile: 'Profile',
    dashboard: 'Dashboard',
    rfqs: 'Open RFQs',
    quotations: 'Quotations',
    operations: 'Operations',
    reports: 'Reports',
    activityLogs: 'Activity Logs',
    products: 'Products',
    customers: 'Customers',
    analytics: 'Analytics',
    store: 'My Store',
    settings: 'Settings',
    help: 'Help',
    schools: 'Schools',
    organizations: 'Organizations',
    vendors: 'Vendors',
    categories: 'Categories',
    inventory: 'Inventory',
    campaignReviews: 'Campaign Reviews',
    bids: 'Bids',
    vouchers: 'Vouchers',
    memberReports: 'Member Reports',
    manageSchools: 'Manage Schools',
    manageOrganizations: 'Manage Organizations',
    pendingVendors: 'Pending Vendors',
    finance: 'Finance',
    directory: 'Directory',
  },
  platform: {
    systemSettings: 'System Settings',
    createCategory: 'Create Category',
    updateCategory: 'Update Category',
    settingsDescription: 'Manage platform-wide configuration values and public setting visibility.',
    configurationRegistry: 'Configuration Registry',
    backDashboard: 'Back to Dashboard',
    settingsUpdated: 'System settings updated successfully.',
    settingsLoadFailed: 'Unable to load system settings.',
    settingsSaveFailed: 'Unable to save settings.',
    schoolsLoadFailed: 'Unable to load organizations.',
    vendorLoadFailed: 'Unable to load vendors.',
    productsLoadFailed: 'Unable to load products.',
    profitLoadFailed: 'Unable to load profit data.',
    deleteSchoolFailed: 'Unable to delete the organization.',
    adminPasswordMin: 'Admin password must be at least 8 characters for a new organization login.',
    schoolSavedFailed: 'Unable to save the organization.',
    noSchools: 'No organizations have been recorded yet.',
    manageSchools: 'Manage organizations: add, update, activate, or deactivate without deleting.',
    resetPasswordHint: 'Enter a new password only if you want to reset the organization login. Leave it blank for no change.',
    addCategory: 'Add Category',
    allStock: 'All Stock',
    categoriesDescription: 'Review the product taxonomy currently used across the platform catalogue.',
    categorizedProducts: 'Categorized Products',
    categorizedProductsInline: 'categorized products',
    categoryDeleteFailed: 'Unable to delete category.',
    categoryDeleted: 'Category deleted successfully.',
    categoryKey: 'Category key',
    categoryKeyPlaceholder: 'Key (example: apparel)',
    displayName: 'Display name',
    editCategory: 'Edit Category',
    inStock: 'In Stock',
    inventoryDescription: 'Manage stock levels for product variations across the platform using the existing product catalogue.',
    inventorySearchPlaceholder: 'Search by product, school, slug, or size',
    lowStock: 'Low Stock',
    noCategoriesDescription: 'Create or update products with categories to populate this module.',
    noCategoriesYet: 'No categories yet',
    noInventoryFound: 'No inventory records found',
    noInventoryFoundDescription: 'Try another search or stock filter.',
    outOfStock: 'Out of Stock',
    paymentCenterDescription: 'Manage platform payment configuration and settings visibility.',
    saveStock: 'Save Stock',
    searchCategories: 'Search categories',
    sortOrder: 'Sort order',
    stockStatusFilter: 'Stock status filter',
    stockValueInput: 'Stock value input',
    totalVariations: 'Total Variations',
    uncategorizedProducts: 'Uncategorized Products',
    variationsLabel: 'variations',
  },
  superadmin: {
    viewAll: 'View All',
    viewAllLowercase: 'View all',
    approve: 'Approve',
    rejecting: 'Rejecting...',
    approving: 'Approving...',
    processing: 'Processing...',
    reject: 'Reject',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    quickActions: 'Quick Actions',
    recentOrders: 'Recent Orders',
    latestSchools: 'Latest Schools',
    rejectOrder: 'Reject Order',
    approveOrder: 'Approve Order',
    rejectThisOrder: 'Reject this order?',
    approveThisOrder: 'Approve this order?',
    approveThisOrderDescription: 'Please confirm if you want to approve this order.',
    backToHome: 'Back to home',
    invitation: 'Invitation',
    editEmail: 'Edit Email',
    editAdminEmail: 'Edit Admin Email',
    resendInvitation: 'Resend Invitation',
    enable: 'Enable',
    disable: 'Disable',
    suspend: 'Suspend',
    unsuspend: 'Unsuspend',
    approvalQueue: 'Approval Queue',
    productApprovalDetails: 'Product Approval Details',
    reviewTrail: 'Review Trail',
    manageProducts: 'Manage Products',
    addProduct: 'Add Product',
    selectSchool: 'Select School',
    noProducts: 'No products',
    students: 'Students',
    orderedStudents: 'Ordered Students',
    notOrdered: 'Not Ordered',
    parentEmail: 'Parent Email',
    parentPhone: 'Parent Phone',
    noStudentsFound: 'No students found',
    qty: 'Qty',
    payment: 'Payment',
    manageSchools: 'Manage Schools',
    allZones: 'All Zones',
    schoolLevelPrimary: 'Rendah',
    schoolLevelSecondary: 'Menengah',
    slug: 'Slug',
    schoolCode: 'School Code',
    zone: 'Zone',
    area: 'Area',
    phoneNumber: 'Phone Number',
    bulkImport: 'Bulk Import School KL',
    importSchools: 'Import Schools',
    importReadyData: 'Import 40 Ready Schools',
    importReadyDescription: 'Automatic import without uploading a file.',
    filterSchool: 'Filter School',
    editSchool: 'Edit School',
    addNewSchool: 'Add New School',
    schoolList: 'School List',
    schoolsCount: '{{count}} schools',
    active: 'Active',
    inactive: 'Inactive',
    reset: 'Reset',
    updateSchool: 'Update School',
    saveSchool: 'Save School',
    deleteSchool: 'Delete School',
    deleteSchoolConfirmation: 'Delete this school? This action cannot be undone.',
    noPendingApprovals: 'No pending approvals',
    noPendingApprovalsDescription: 'There are no products pending review right now.',
    viewInventory: 'View Inventory',
    schoolsRegistered: 'Schools registered',
    ordersRecorded: 'Orders recorded',
    platformUsers: 'Platform users',
    paidRevenue: 'Paid revenue',
    awaitingReview: 'Awaiting review',
    pendingApprovalsTitle: 'Pending Approvals',
    todaysActivity: 'Today\'s Activity',
    addOrganization: 'Add Organization',
    pendingVendors: 'Pending Vendors',
    bidsManagement: 'Bids Management',
    printLabels: 'Print Labels',
    totalSchools: 'Total Schools',
    totalOrders: 'Total Orders',
    totalRevenue: 'Total Revenue',
    totalUsers: 'Total Users',
    pendingApprovalsCount: 'Pending Approvals',
    goodEvening: 'Good evening, Super Admin',
    dashboardSubtitle: 'Manage the Cheeco platform',
    dashboardDescription: 'Monitor schools, orders, vendors and platform activities in real time.',
    reason: 'Reason',
    noAdmin: 'No admin',
    pendingActivation: 'Pending Activation',
    invitationSent: 'Invitation Sent',
    expired: 'Expired',
    unknown: 'Unknown',
    noOrganizationsFound: 'No organizations found',
    noOrganizationsDescription: 'There are no organizations in this status.',
    organizationStatusUpdated: 'Organization status updated.',
    invitationRegenerated: 'Invitation regenerated and sent.',
    resetAdminPassword: 'Reset admin password? A new invitation will be sent.',
    passwordReset: 'Password reset. New invitation sent.',
    adminEmailUpdated: 'Admin email updated.',
    schoolDeleted: 'School deleted successfully.',
    importCompleted: 'Import completed: {{count}} schools imported successfully.',
    readyDataImported: 'Ready data imported: {{count}} schools processed.',
    importFileRequired: 'Please select an import file (.xlsx or .csv).',
    adminPasswordMin: 'Default admin password must be at least 8 characters.',
    selectImportFile: 'Select school from ready list (optional)',
    category: 'Category',
    domainOptional: 'Domain (optional)',
    resetAdminPasswordPlaceholder: 'Reset Admin Password (optional)',
    adminPasswordPlaceholder: 'Admin Password',
    loadingDashboard: 'Loading dashboard...',
    loadingApprovals: 'Loading approvals...',
    unableToLoadSchools: 'Unable to load schools.',
    unableToLoadOrganizations: 'Unable to load organizations.',
    unableToLoadPendingApprovals: 'Unable to load pending approvals.',
    sent: 'Sent',
    disableOrganization: 'This organization will lose access to the dashboard.',
    suspendOrganization: 'This organization will be suspended immediately.',
    rejectOrganization: 'This organization will be rejected and disabled.',
    approveOrganization: 'This organization will be activated and an invitation email will be sent to the admin.',
    noPendingOrders: 'No pending orders for approval.',
    orderList: 'Order List',
    ordersCount: '{{count}} orders',
    noOrdersFound: 'No orders found',
    noOrdersDescription: 'There are no orders recorded yet.',
    details: 'Details',
    harga: 'Price',
    hargaJualan: 'Selling Price',
    kosAsas: 'Base Cost',
    deadline: 'Deadline',
    submitted: 'Submitted',
    front: 'Front',
    back: 'Back',
    logo: 'Logo',
    noImage: 'No image',
    schoolInformation: 'School Information',
    school: 'School',
    contact: 'Contact',
    email: 'Email',
    phone: 'Phone',
    status: 'Status',
    reviewedAt: 'Reviewed At',
    reviewedBy: 'Reviewed By',
    reviewerEmail: 'Reviewer Email',
    noAdditionalDescription: 'No additional description.',
    variations: 'Variations',
    stock: 'Stock',
    rejectionReason: 'Rejection Reason',
    loadingProductApprovalDetails: 'Loading product approval details...',
    productNotFound: 'Product not found.',
    allSchoolProductsWaiting: 'All school products waiting for review',
    pendingCount: 'Pending Count',
    noPendingProductsReview: 'No pending products to review right now.',
    orderApprovalQueue: 'Order Approval Queue',
    pendingApproval: 'Pending Approval',
    defaultAdminPassword: 'Default admin password',
    searchNameSlugArea: 'Search name/slug/area',
    superAdmin: 'Super Admin',
    loginDescription: 'Sign in to the platform governance portal.',
    operationsCenter: 'Operations Center',
    governanceDashboard: 'Governance Dashboard',
    governanceSubtitle: 'Platform health, escalations, and cross-tenant oversight',
    operationsCenterSubtitle: 'What needs your attention today',
    attentionRequired: 'Attention Required',
    pendingProductsApproval: 'Products awaiting approval',
    pendingStoreUpdates: 'Store updates pending review',
    pendingOrganizations: 'Organizations pending setup',
    noAttentionRequired: 'Nothing needs your attention right now.',
    platformHealth: 'Platform Health',
    everythingLooksNormal: 'Everything looks normal',
    viewDetailedReports: 'View Detailed Reports',
    recentActivity: 'Recent Activity',
    viewFullActivityLog: 'View Full Activity Log',
    registered: 'registered',
    order: 'Order',
    from: 'from',
    reviewAll: 'Review All',
    productsActive: 'Active Products',
    failedPayments: 'Failed Payments',
    expiredInvitations: 'Expired Invitations',
    operationsQueue: 'Operations Queue',
    noOperationsQueue: 'Nothing in the queue right now.',
    viewOperationsCenter: 'View Operations Center',
    activate: 'Activate',
    addPlatformAdmin: 'Add Platform Admin',
    addStaff: 'Add Staff',
    adminContact: 'Admin / Contact',
    adminEmailPlaceholder: 'Admin email',
    create: 'Create',
    createStaff: 'Create Staff',
    custom: 'Custom',
    deactivate: 'Deactivate',
    department: 'Department',
    disabled: 'Disabled',
    editStaff: 'Edit Staff',
    invitationReset: 'Invitation reset successfully.',
    jobTitle: 'Job Title',
    loadingActivity: 'Loading activity...',
    loadingStaff: 'Loading staff...',
    manageOrganizationsDescription: 'Manage organization status, invitations, and admin accounts.',
    manageUsers: 'Manage Users',
    manageUsersSubtitle: 'Create platform administrators and control account access.',
    newPassword: 'New password',
    noActivity: 'No activity',
    noActivityDescription: 'No activity logs found for this staff member.',
    noStaffDescription: 'There are no staff members yet. Create one to get started.',
    noStaffFound: 'No staff found',
    noUsersDescription: 'There are no platform users available yet.',
    noUsersFound: 'No users found',
    permissions: 'Permissions',
    resetPassword: 'Reset Password',
    setNewPassword: 'Set a new password for',
    staffActivity: 'Staff Activity',
    staffCreated: 'Staff created successfully.',
    staffDisabled: 'Staff disabled.',
    staffEnabled: 'Staff enabled.',
    staffManagement: 'Staff Management',
    staffManagementDescription: 'Create, manage, and monitor internal platform staff.',
    staffUpdated: 'Staff updated successfully.',
    superAdminAccount: 'Super Admin Account',
    thisUser: 'this user',
    unableToLoadActivity: 'Unable to load activity logs.',
    unableToLoadDashboard: 'Unable to load dashboard.',
    unableToLoadStaff: 'Unable to load staff at this time.',
    unableToResetInvitation: 'Unable to reset invitation.',
    unableToSaveStaff: 'Unable to save staff. Please try again.',
    unableToUpdateStatus: 'Unable to update status.',
    usersCount: '{{count}} users',
    yourPassword: 'Your password',
  },
  email: {
    resetTitle: 'Reset Password',
    resetIntro: 'We received a request to reset the password for your Cheeco account.',
    resetTenantIntro: 'We received a request to reset the password for {{tenant}}.',
    resetInstruction: 'Click the button below to set a new password. This link is valid for {{minutes}} minutes.',
    resetButton: 'Reset Password',
    fallbackLink: 'If the button does not work, use this link:',
    ignoreReset: 'If you did not request this, you can ignore this email.',
  },
  membership: {
    title: 'School Verification',
    statusMember: 'Verified',
    statusPending: 'Pending Verification',
    statusException: 'Under Review',
    verifiedMessage: 'You can now join campaigns and place orders.',
    pendingMessage: 'Verification could not be completed. Your request has been sent for review.',
    submitClaim: 'Submit Verification',
    childName: 'Child\'s Name',
    childClass: 'Child\'s Class',
    childHouse: 'Child\'s Sports House',
    pendingQueue: 'Pending Verifications',
    confirmMember: 'Confirm Membership',
    markException: 'Mark as Exception',
    escalatedCases: 'Escalated Cases',
    settings: 'Verification Settings',
    autoEscalationHours: 'Auto-Escalation (Hours)',
    sportsHouseRequired: 'Sports House Required',
    allowManualOverride: 'Allow Manual Override',
    membershipRequired: 'Membership Required',
    campaignGate: 'Campaign Gate Enabled',
    lockedCampaign: 'Complete school verification to join this campaign.',
    myMemberships: 'My Memberships',
  },
  onboarding: {
    minCharacters: 'Please enter at least 2 characters',
    noSchoolsFoundTerm: 'No schools found. Try a different search term.',
    searchFailed: 'Search failed. Please try again.',
    enterName: 'Please enter your name',
    nameMinCharacters: 'Name must be at least 2 characters',
    enterSchoolName: 'Please enter a school name',
    selectSchool: 'Please select a school',
    setupFailed: 'Failed to complete setup. Please try again.',
    schoolStaff: 'School Staff',
    createOrJoin: 'Create a new school or join an existing school',
    joinYourChild: 'Join your child\'s school using an invitation link or QR Code',
    yourName: 'Your Name',
    joinAs: 'Join As',
    setup: 'Setup',
    step: 'Onboarding step',
    progress: 'Onboarding progress',
    welcome: 'Welcome to Cheeco!',
    whatIsYourName: 'What is your name?',
    yourFullName: 'Your full name',
    iAmJoiningAs: 'I am joining as...',
    selectHowJoining: 'Select how you are joining',
    howWouldYouLike: 'How would you like to continue?',
    createNewSchool: 'Create a New School',
    setupSchoolProfile: 'Set up your school profile and start managing campaigns',
    joinExistingSchool: 'Join an Existing School',
    searchForSchool: 'Search for your school and request to join',
    schoolNameExample: 'e.g., SMK Bukit Jalil',
    youWillBecomeAdmin: 'You will become the School Administrator and can manage campaigns, members, and settings.',
    settingUp: 'Setting up...',
    createSchoolAndContinue: 'Create School & Continue',
    findYourSchool: 'Find Your School',
    searchBySchoolName: 'Search by school name or school code. Your request will be sent to the School Owner for approval.',
    searchByNameOrCode: 'Search by name or school code',
    searching: 'Searching...',
    selected: 'Selected:',
    statusAfterSetup: 'Status after setup:',
    requestToJoinSchool: 'Request to Join School',
    parentAccess: 'Parent Access',
    parentsOfficialInvitations: 'Parents join schools through official invitations only.',
    howToJoin: 'How to join:',
    openInvitationLink: 'Open an invitation link from your school',
    scanQRCode: 'Scan a QR Code provided by the school',
    enterInvitationCode: 'Enter an invitation code',
    contactAdmin: 'Contact your school administrator if you need an invitation.',
    continueAsParent: 'Continue as Parent',
  },
  schoolSetup: {
    imageTypesAllowed: 'Only PNG, JPG, or WebP images are allowed.',
    logoSizeLimit: 'Logo must be smaller than 2 MB.',
    schoolNameRequired: 'School Name is required.',
    schoolAddressRequired: 'School Address is required.',
    stateRequired: 'State is required.',
    contactNumberRequired: 'Contact Number is required.',
    profileSavedRefreshing: 'School profile saved successfully. Refreshing...',
    profileSaved: 'School profile saved.',
    unableToSaveProfile: 'Unable to save school profile.',
    unableToCompleteSetup: 'Unable to complete setup.',
    completeProfile: 'Complete School Profile',
    required: 'Required',
    createFirstCampaign: 'Create Your First Campaign',
    inviteSchoolMembers: 'Invite School Members',
    optional: 'Optional',
    title: 'School Setup',
    completeProfileDescription: 'Complete your school profile to unlock the full platform. This takes less than 2 minutes.',
    completeProfileDescriptionShort: 'Complete your school profile to unlock your school dashboard.',
    completed: 'Completed',
    profile: 'School Profile',
    identityDescription: 'This becomes your identity across all campaigns and reports.',
    logo: 'School Logo',
    changeLogo: 'Change logo',
    uploadLogo: 'Upload school logo',
    logoFormatHint: 'PNG, JPG or WebP. Max 2 MB.',
    schoolName: 'School Name',
    schoolNamePlaceholder: 'e.g. SMK Putra Impian',
    schoolAddress: 'School Address',
    addressPlaceholder: 'Full address including postcode',
    state: 'State',
    statePlaceholder: 'e.g. Selangor',
    contactNumber: 'Contact Number',
    contactNumberPlaceholder: 'e.g. +60 12-345 6789',
    saveAndContinue: 'Save & Continue',
    profileComplete: 'School profile complete!',
    identityActive: 'Your school identity is now active across the platform.',
    startOrderDescription: 'Start a t-shirt or uniform order for your school.',
    optionalStaffDescription: 'Optional — add teachers and class representatives.',
  },
  pendingAccess: {
    title: 'Pending School Access',
    yourRequestToJoin: 'Your request to join',
    waitingApproval: 'is waiting for approval from the School Owner.',
    notificationInfo: 'You will receive a notification once the School Owner approves your request. This usually takes 1-2 business days.',
    schoolCode: 'School Code:',
    logOut: 'Log out',
  },
  joinSchool: {
    searchPlaceholder: 'Search by name, school code, or location',
    searchPlaceholderExample: 'e.g., SMK Bukit Jalil or CHC-12345',
    noSchoolsFound: 'No schools found. Try a different search.',
    join: 'Join',
    backToSignIn: 'Back to Sign In',
  },
  notifications: {
    unreadCount: 'Notifications: {{count}} unread',
    markRead: "Mark as read",
    archive: "Archive",
    saving: "Saving...",
    timelineEvent: "Timeline event",
    title: 'Notifications',
    menu: 'Notification menu',
    markAllRead: 'Mark all read',
    empty: 'No notifications yet',
    clickToView: 'Click to view →',
    unread: 'Unread',
  },
  dashboard: {
    finishSchoolSetup: 'Finish your school setup',
    quickSetupSteps: 'Complete the quick setup steps to unlock your school dashboard.',
    goToSetup: 'Go to Setup',
    loadingData: 'Loading dashboard data...',
  },
  parentOrder: {
    portalTitle: 'Parent Portal',
    dashboard: 'Dashboard',
    productImage: 'Product Image',
    previewImage: 'Preview product image',
    closePreview: 'Close image preview',
    priceDeadline: 'Price + Deadline',
    productDetails: 'Product Details',
    sleeveTypeLabel: 'Sleeve Type: Short Sleeve, Long Sleeve',
    campaignPayment: 'Campaign / Payment',
    selectCampaign: 'Select Campaign',
    defaultNoCampaign: 'Default (no campaign)',
    sportsHouse: 'Sports House / Team',
    sleeve: 'Sleeve',
    size: 'Size',
    quantity: 'Quantity',
    total: 'Total',
    shortSleeve: 'Short Sleeve',
    longSleeve: 'Long Sleeve',
    noItemsFound: 'No order items found for this reference.',
    orderNumber: 'Order Number',
    selectSportsHouse: 'Select Sports House',
    orEnterManually: 'or enter manually',
    paymentMethod: 'Payment Method',
    voucherCode: 'Voucher Code',
    enterVoucherCode: 'Enter voucher code',
    addToCart: 'Add to Cart',
    orderClosed: 'Order Closed',
    sizeChart: 'Size Chart',
    sizeChartNotSet: 'Size chart has not been set.',
    sizeChartPlaceholder: 'Measurement / size chart notes',
    measurement: 'Measurement',
    unitPrice: 'Unit Price',
    itemTotal: 'Item Total',
    orderSuccess: 'Order created successfully. Please continue with payment.',
    orderRecorded: 'Order recorded. Waiting for payment or approval.',
    totalAmount: 'Total: {{amount}}',
    back: 'Back',
    editOrders: 'Edit Orders',
    orderLabel: 'Order',
    orderIdLabel: 'Order #{{number}}',
    fullNameClassHint: 'Enter the exact full name and class. If there is no match, the system will notify you that the student was not found.',
    save: 'Save',
    receiptTitle: 'Receipt — Orders',
    orderList: 'Order List',
    viewOrderDetails: 'View Order Details',
    paymentSource: 'Payment Source',
    parentPayment: 'Parent Payment',
    redirectingToOrder: 'Redirecting to order details in {{count}}s...',
    paymentCompleted: 'Payment completed. The order has been recorded.',
    memberName: '{{member}} Name',
    orderForm: 'Order Form',
    cart: 'Cart',
    viewCurrentOrder: 'View Current Order',
    viewCart: 'View Cart',
    saving: 'Saving...',
    saveChanges: 'Save Changes',
    saveAndCheckout: 'Save & Checkout',
    memberItem: '{{member}} Item #{{index}}',
    orderId: 'Order ID',
    backToOrderList: 'Back to Order List',
    ended: 'Ended',
    endedClosed: 'Ended! / Closed',
    reviewBeforeOrder: "Review the student and size details before placing your order.",
    fullNameClassHintDynamic: 'Enter the exact full name and {{group}}. If there is no match, the system will notify you that the {{member}} was not found.',
    totalLabel: 'TOTAL',
    backToDashboard: 'Back to Dashboard',
    product: 'Product',
    productAndOrganization: 'Product and {{organization}}',
    fundingCodeRequired: 'Funding code is required for this campaign.',
    orderWindowClosed: 'Ordering is closed. The closing date for this product has passed.',
    orderRedirecting: 'Order created successfully. Redirecting to payment...',
    itemAddedToCart: 'Item added to cart.',
    sportsHousePlaceholder: 'Sports House / Team',
    sportsHouseOptional: 'Sports House / Team (optional)',
    hi: "Hi, {{name}} 👋",
    familyNextStep: "Here's what to do next for your family.",
    orderNow: "Order now",
    browseAll: "Browse all",
    openLabel: "Open:",
    closeLabel: "Close:",
    productCount: "{{count}} Product",
    recentOrders: "Recent orders",
    viewAll2: "View all",
    track: "Track",
    myCampaigns: "My Campaigns",
    browseCampaigns: "Browse active campaigns across your connected groups",
    browseCampaignsDesc: "Track open campaigns, see assigned products, and jump straight into ordering for the organizations linked to your account.",
    kpiTotal: "Total",
    kpiActive: "Active",
    kpiClosed: "Closed",
    viewOrders: "View Orders",
    studentsCount: "Students ({{count}})",
    availableProducts: "Available Products",
    checkout: "Checkout",
    checkoutMulti: "Multi-Group Checkout",
    checkoutDesc: "Review your items and complete your purchase.",
    checkoutMultiDesc: "Manage products from multiple groups and complete everything in one secure checkout.",
    continueShopping: "Continue Shopping",
    emptyCart: "Your cart is empty",
    emptyCartDesc: "Browse available campaigns and add items to your cart.",
    browseCampaignsBtn: "Browse Campaigns",
    checkoutSuccess: "Checkout successful. All items were processed under the same cart ID.",
    studentCount: "{{count}} Student",
    addStudent: "Add Student",
    classLabel2: "Class",
    optionsAria: "Options",
    noStudentsLinked: "No students linked to this school yet.",
    pmOnlinePayment: "Online Payment",
    pmVoucher: "Voucher Code",
    pmQrVoucher: "QR Voucher",
    pmManualTransfer: "Manual Bank Transfer",
    manualPaymentSelected: "Manual payment selected. Order will be sent for approval before payment is confirmed.",
    qrVoucherCode: "QR Voucher Code",
    timeDays: "{{n}} hari",
    timeHours: "{{n}} jam",
    timeMinutes: "{{n}} min",
    productCode: "Code: {{value}}",
    productMaterial: "Material: {{value}}",
    productWeight: "Weight: {{value}}",
    shortSleevePrice: "Short Sleeve Price: {{value}}",
    longSleevePrice: "Long Sleeve Price: {{value}}",
    colorsLabel: "Colors: {{value}}",
    deadlineLabel: "Deadline: {{value}}",
    ordersClosed: "Orders closed.",
    sportsHouseRequired: "Please select a sports house for every {{member}}.",
    addMemberAction: "+ Add {{member}}",
    addMemberGroup: "+ Add {{member}} / {{group}}",

    // ParentOrders page
    ordersTitle: "Orders",
    ordersSubtitle: "Track and pay for your orders.",
    filterAll: "All",
    filterToPay: "To Pay",
    filterPaid: "Paid",
    loadingOrders: "Loading your orders…",
    nothingToPay: "Nothing to pay",
    noPaidOrders: "No paid orders",
    noOrdersYet: "No orders yet",
    ordersEmptyDesc: "Orders you place will appear here with live status.",
    tryDifferentFilter: "Try a different filter to see more orders.",
    paying: "Paying...",
    payBtn: "Pay",
    unableToLoadOrders: "Unable to load your orders.",
    unableToInitPayment: "Unable to initialize online payment.",
    // ParentHome
    homeUnableToLoad: "Unable to load your home.",
    homeNoActiveCampaigns: "No active campaigns",
    homeNoProductsYet: "No products available yet",
    homeNoProductsDesc: "New campaigns will appear here once your school publishes them.",
    homeNoProductsDesc2: "Your school has published campaigns but hasn't added products yet. Check back soon!",
    // ParentCampaigns
    unableToLoadCampaigns: "Unable to load your campaigns.",
    loadingCampaigns: "Loading campaigns...",
    noCampaignsAvailable: "No campaigns available",
    noCampaignsAvailableDesc: "Your linked organizations do not have any active or closed campaigns yet.",
    // ParentCart
    orderCreatedPayment: "Order created. Proceeding to payment...",
    unableToInitPaymentRetry: "Unable to initialize online payment. You can retry from the receipt page.",
    orderCreatedComplete: "Order created. Complete payment from the receipt page.",
    cartSubmitted: "Cart submitted successfully.",
    unableToCheckoutCart: "Unable to checkout cart.",
    removeItemAria: "Remove item",
    // ParentReceipt
    unableToLoadReceipt: "Unable to load receipt.",
    loadingReceipt: "Loading receipt...",
    paymentCompletedSummary: "Payment completed. This is your order summary.",
    unableToFindOrgPaymentLink: "Unable to find the organization payment link for this order.",
    unableToStartOnlinePayment: "Unable to start online payment.",
    unableToGeneratePdf: "Unable to generate invoice PDF.",
    // ParentOrder / ParentOrderEdit
    unableToLoadProducts: "Unable to load products.",
    unableToLoadChildData: "Unable to load child data.",
    unableToLoadOrderItems: "Unable to load order items.",
    orderNotFound: "Order was created, but the order ID was not found. Please check your dashboard.",
    loadingOrderForm: "Loading order form...",
    exampleOrderNo: "e.g. ABC-2027",
    selectSavedMember: "Select saved {{member}} (optional)",
    lookingUpRecords: "Looking up school records for {{name}}...",
    thisMember: "this member",
    unableToLoadOrder: "Unable to load the order.",
    // ParentCartReceipt
    loadingCartReceipt: "Loading cart receipt...",
    unableToLoadCartReceipt: "Unable to load cart receipt.",
    paymentOrderSummary: "Payment / Order Summary",
    cartReceiptTitle: "Cart receipt",
    onePaymentAllSchools: "One payment for all schools",
    checkoutComplete: "Checkout complete",
    aggregateCartDesc: "All orders in your cart are covered by one payment.",
    allOrdersProcessed: "All orders in this cart were processed together.",
    backToCart: "Back to cart",
    cartIdLabel: "Cart ID",
    overallTotal: "Overall total",
    paidBy: "Paid By",
    groupsInCart: "Groups in this cart",
    groupsInCartDesc: "Orders are grouped by group for easier review.",
    orderColon: "Order: {{number}}",
    orderCount: "{{count}} order(s)",
    orgTotal: "{{organization}} total",
    sizeLabel: "Size {{size}}",
    unitCount: "{{count}} unit",
    paymentRequired: "Payment required",
    completeOnlinePayment: "Complete your online payment",
    pendingPaymentDesc: "Your order has been created but payment is still pending. Click Pay Now to proceed to the payment gateway.",
    initializingPayment: "Initializing payment...",
    payNowBtn: "Pay Now",
    nextStep: "Next step",
    continueBrowsingOrDashboard: "Continue browsing or return to dashboard",
    cartCompleteDesc: "This cart is complete. You can return to the dashboard to add another cart.",
    openCart: "Open cart",
    paymentGatewayError: "Payment gateway did not return a payment URL. Please try again or contact support.",
    unableToInitOnlinePayment: "Unable to initialize online payment. Please try again.",
    pmOrgSponsored: "Organization Sponsored",
    pmManual: "Manual Payment",
    pmCash: "Cash",
    pmBankTransfer: "Bank Transfer",
    pmCheque: "Cheque",
    pmComplimentary: "Complimentary / FOC",
    psParent: "Parent",
    psOrganization: "Organization",
    psManual: "Manual",
    psComplimentary: "Complimentary",
    // TaskList
    goodMorning: "Good Morning",
    goodAfternoon: "Good Afternoon",
    goodEvening: "Good Evening",
    taskOpen: "Open",
    taskClosed: "Closed",
    daysLeftOne: "{{days}} day left",
    daysLeftMany: "{{days}} days left",
    activeTasks: "Active Tasks",
    pendingOrders: "Pending Orders",

  },
  messages: {
    saveSuccess: 'Record saved successfully.',
    updateSuccess: 'Changes updated successfully.',
    requiredWarning: 'Please complete all required fields.',
    saveError: 'Unable to save the record. Please try again.',
    csvImportInfo: 'CSV import completed successfully.',
    loadNotificationsError: 'Unable to load notifications. Please try again.',
    updateNotificationError: 'Unable to update notification. Please try again.',
    markAllError: 'Unable to mark all notifications. Please try again.',
    archiveError: 'Unable to archive notification. Please try again.',
    updateSettingsError: 'Unable to update notification settings. Please try again.',
    loadInvoiceError: 'Unable to load invoice. Please try again.',
    loadInvoicePdfError: 'Unable to load the invoice PDF. Please try again.',
  },
  rejectOrder: {
    title: 'Reject Order',
    provideReason: 'Please provide a reason',
    reason: "Reason",
    reasonRequired: "Reason is required.",
  },
  funding: {
    addSourceHint: 'Add a funding source for this campaign so orders can be sponsored or funded by third parties.',
    addFirstSource: 'Add First Source',
    editSourceAria: 'Edit funding source',
    deleteSourceAria: 'Delete funding source',
    usageDescription: 'Orders using this funding source will be shown here.',
  },  org: {
    adminsTitle: "Organisation Administrators",
    noMembersImported: "No members imported yet.",
    addLogo: "Add Logo",
    uploadLogo: "Upload Logo",
    dismiss: "Dismiss",
    payoutAccounts: "Payout Accounts",
    clickToUploadLogo: "Click to upload logo",
    orgTypeSchool: "School",
    orgTypeClub: "Club",
    orgTypeAssociation: "Association",
    orgTypeNgo: "NGO",
    orgTypeCommunity: "Community",
    orgTypeCompany: "Company",
    malaysianBank: "Malaysian Bank Account",
    paypal: "PayPal Account",
    noPayouts: "No Payout Accounts Added",
    deletePayout: "Delete Payout Account",
    noSpacesDashes: "No spaces or dashes",
    idNric: "NRIC / MyKad",
    idPassport: "Passport",
    idBrn: "Business Reg (BRN)",
    currencyMyr: "Malaysian Ringgit (RM)",
    currencyUsd: "US Dollar (USD)",
    currencySgd: "Singapore Dollar (SGD)",
    autofillPh: "Leave blank to autofill",
    accountEmailPh: "account@domain.com",
    dashDesc: "Manage your organisation campaigns, members, orders, and reports.",
    loadingMetrics: "Loading workspace metrics...",
    noCampaigns: "No campaigns created yet.",
    createFirstCampaign: "Create your first campaign to start receiving member orders.",
    noOrders: "No orders placed yet.",
    ordersHint: "Orders will appear here when members purchase from published campaigns.",
    membersTitle: "Organisation Members",
    membersDesc: "View and manage members belonging to your organisation.",
    searchMembersPh: "Search members by name or email...",
    loadingMembers: "Loading members...",
    noMembers: "No members found.",
    inviteHint: "Invite team members or users to your organisation.",
    member: "Member",
    addMember: "Add Organisation Member",
    emailAddress: "Email Address",
    emailPh: "member@example.com",
    reportsTitle: "Organisation Reports",
    reportsDesc: "Financial, sales, and campaign performance analytics.",
    loadingReports: "Generating report metrics...",
    performanceBreakdown: "Performance Breakdown",
    performanceDesc: "Detailed campaign performance metrics for your organisation.",
    ordersTitle: "Organisation Orders",
    ordersDesc: "View orders placed by members across your campaigns.",
    searchOrdersPh: "Search by Order ID or buyer name...",
    loadingOrders: "Loading orders...",
    navigation: "Navigation",
    allCampaigns: "All Campaigns",
    createCampaign: "Create Campaign",
    loadingOrg: "Loading organisation…",
    accessDenied: "Access Denied",
    accessDeniedDesc: "Access denied. Your account cannot use the Organization Verification module.",
    campaignYear: "Campaign Year",
    selectAllOrders: "Select all orders ({{count}})",
    groupLabel: "Group",
    orderQueue: "Order Queue",
    showingOf: "Showing {{shown}} of {{total}} orders in current filters",
    searchOrderPh: "Search order, buyer, class, size, amount",
    allStatus: "All Status",
    paidOnline: "Paid Online",
    allTypes: "All Types",
    saveOrder: "Save Order",
    allOrders: "All",
    pickHeader: "Pick",
    memberNameWith: "{{member}} Name",
    noActiveProducts: "No active products are available for this organization",
    awaitingApprovalStatus: "Awaiting Approval",
    termStudent: "Student",
    termClass: "Class",
    termClasses: "Classes",
    termParentOnline: "Parent Online",
    termAdminAssisted: "Admin Assisted",
    termMember: "Member",
    termOnlineBuyer: "Online Buyer",
    termCommittee: "Committee",
    termDepartment: "Department",
    termGroup: "Group",
    termTeam: "Team",
    termEmployee: "Employee",
    termVolunteer: "Volunteer",
    studentNameHeader2: "Student Name",
    sportsHouseHeader2: "Sports House",
    createAssistedOrder: "Create Assisted Order",
    assistedModeDesc: "Assisted checkout mode for offline buyers or assisted walk-in purchases.",
    selectProduct: "Select Product",
    studentName: "Student Name",
    phoneNumber: "Phone Number",
    address: "Address",
    size: "Size",
    quantity: "Quantity",
    classLabel: "Class",
    stockSuffix: "{{size}} ({{stock}} stock)",
    orderHeader2: "Order",
    buyerHeader2: "Buyer",
    qtyHeader2: "Qty",
    amountHeader: "Amount",
    typeHeader: "Type",
    lastImportLabel: "Last import:",
    noStudentsImported: "No students imported yet.",
    paidOrdersKpi: "Paid Orders",
    pendingOrdersKpi: "Pending Orders",
    studentsOrderedOfShort: "Students ordered / Total students",
    membersKpi: "Members",
    teacherRole: "Teacher",
    administratorRole: "Administrator",
    pendingSetup: "Pending Setup",
    searchMembersPh: "Search members...",
    noMembersFound: "No members found",
    uploadCsvHint: "Upload your student CSV to get started.",
    memberImportDesc: "Upload your member roster from a CSV file, or download the template to fill in first.",
    directoryDesc: "Directory of organisation members and registered accounts.",
    orgUploadCsvHint: "Upload your member CSV to get started.",
    statusActive: "active",
    fewerThanDb: "The uploaded CSV contains fewer {{members}} than your current database.",
    newMembersToImport: "New {{members}} to be imported:",
    previousReplaced: "Previous {{members}} replaced:",
    labelsReady: "{{count}} labels are ready for printing",
    allOrdered: "All students have ordered",
    readyForApproval: "Ready for approval",
    readyForApprovalDesc: "Student list validated. Submit this campaign for review.",
    awaitingApproval: "Awaiting approval",
    awaitingApprovalDesc: "{{name}} has been submitted and is pending Super Admin review.",
    approvedReady: "Approved — ready to publish",
    approvedReadyDesc: "{{name}} is approved. Publish to open ordering.",
    closingSoon: "Campaign closing soon",
    closingSoonDesc: "{{name}} closes in {{days}} days.",
    sendRemindersHint: "Send reminders to drive orders.",
    noDescription: "No description",
    reportSuffix: "Reports",
    dashTitle: "School operations overview.",
    setupComplete: "Setup Complete",
    campaignRunning: "Campaign Running",
    runningCampaign: "RUNNING CAMPAIGN",
    published: "Published",
    opened: "Opened:",
    closes: "Closes:",
    daysLeft: "({{days}}d left)",
    orderProgress: "Order Progress",
    studentsOrderedOf: "Students ordered / Total students:",
    studentsNeedOrder: "{{count}} students still need to order",
    viewCampaign: "View Campaign",
    sendReminders: "Send Reminders",
    campaignTimeline: "Campaign Timeline",
    tlCreated: "Created",
    tlSubmitted: "Submitted",
    tlApproved: "Approved",
    tlPublished: "Published",
    ordersOpen: "Orders Open",
    distribution: "Distribution",
    kpiStudents: "STUDENTS",
    kpiParentsLinked: "PARENTS LINKED",
    kpiOrders: "ORDERS",
    kpiNotOrdered: "NOT ORDERED",
    actionRequired: "Action Required",
    studentsHaventOrdered: "{{count}} students haven't ordered",
    daysUntilClosing: "{{days}} days until closing ({{date}}).",
    recentOrders: "Recent Orders",
    viewAll: "View all",
    orderHeader: "ORDER",
    buyerHeader: "BUYER",
    classHeader: "CLASS",
    qtyHeader: "QTY",
    statusHeader: "STATUS",
    closesOn: "Closes {{date}}",
    itemsCount: "{{count}} items",
    viewAction: "View",
    membersTitle: "Members",
    membersDesc: "Manage your school administrators and member directory.",
    schoolAdmins: "School Administrators",
    schoolAdminsDesc: "People who manage this school account.",
    addAdministrator: "Add Administrator",
    owner: "Owner",
    active: "Active",
    studentImport: "Student Import",
    studentImportDesc: "Upload your student roster from a CSV file, or download the template to fill in first.",
    lastImport: "LAST IMPORT",
    never: "Never",
    downloadCsvTemplate: "Download CSV Template",
    uploadCsv: "Upload CSV",
    schoolMembers: "School Members",
    schoolMembersDesc: "Students, parents and teachers. Members are created automatically through CSV import, parent claims, and teacher invitations.",
    totalKpi: "TOTAL",
    studentsKpi: "STUDENTS",
    inactiveKpi: "INACTIVE",
    filterStudents: "Students",
    filterInactive: "Inactive",
    exportCsv: "Export CSV",
    importCsv: "Import CSV",
    nameHeader: "NAME",
    classDeptHeader: "CLASS / DEPT",
    sportsHouseHeader: "SPORTS HOUSE",
    parentLinkedHeader: "PARENT LINKED",
    actionsHeader: "ACTIONS",
    notLinked: "Not linked",
    linked: "Linked",
    showingMembers: "Showing {{from}}–{{to}} of {{total}} members",
    rowsPerPage: "Rows per page:",
    previous: "Previous",
    next: "Next",
    reportsTitle: "Campaign Reports",
    reportsDesc: "Analyze ordering, payment, and delivery records in campaign context.",
    campaignLabel: "CAMPAIGN",
    overview: "OVERVIEW",
    totalEnrolled: "Total enrolled",
    acrossAllCampaigns: "Across all campaigns",
    paymentConfirmed: "Payment confirmed",
    awaitingPayment: "Awaiting payment",
    completionDelivery: "ORDER COMPLETION & DELIVERY",
    completionPct: "COMPLETION %",
    paidAmount: "PAID AMOUNT",
    collected: "Collected",
    inProduction: "IN PRODUCTION",
    beingMade: "Being made",
    packing: "PACKING",
    beingPacked: "Being packed",
    inDelivery: "IN DELIVERY",
    onTheWay: "On the way",
    completed: "COMPLETED",
    delivered: "Delivered",
    allStudents: "All Students",
    notLinkedLabel: "Not Linked",
    orderedLabel: "Ordered",
    pendingLabel: "Pending",
    studentNameHeader: "STUDENT NAME",
    parentStatusHeader: "PARENT STATUS",
    orderStatusHeader: "ORDER STATUS",
    lastOrderHeader: "LAST ORDER",
    notOrdered: "Not Ordered",
    showingStudents: "Showing {{from}}–{{to}} of {{total}} students",
    opsTitle: "Campaign Operations",
    opsDesc: "Orders, production, packing, and delivery are managed from campaign context.",
    printLabelDisabled: "Print label is disabled for this school. Contact Super Admin.",
    openLabelPrint: "Open Label Print Center",
    totalOrdersKpi: "TOTAL ORDERS",
    onlineKpi: "ONLINE",
    manualKpi: "MANUAL",
    printLabelsKpi: "PRINT LABELS",
    orgBadge: "ORGANIZATION",
    unableToLoadVerification: "Unable to load {{member}} verification.",
    reminderSentTo: "Reminder sent to {{count}} {{members}}.",
    labelStudent: "Student",
    labelStudents: "Students",
    labelMember: "Member",
    labelMembers: "Members",
    labelEmployee: "Employee",
    labelEmployees: "Employees",
    labelVolunteer: "Volunteer",
    labelVolunteers: "Volunteers",
    labelPrincipal: "Principal",
    labelPresident: "President",
    labelManager: "Manager",
    labelOwner: "Owner",
    labelCoordinator: "Coordinator",
    labelAdministrator: "Administrator",
    memberCenterWith: "{{name}} {{member}} Center",
    verifyImportWith: "Import and verify {{members}}, then send reminders by group or cohort.",
    uploadMemberListWith: "Upload {{label}} List or Organization Data",
    notifyContactsWith: "Notify contacts for {{members}} who have not ordered.",
    totalWithLabel: "Total {{members}}",
    directoryWith: "{{member}} Directory",
    noWith: "No {{members}} found",
    uploading: "Uploading...",
    loadingVerification: "Loading verification data...",
    filterBy: "Filter {{type}}:",
    breakdownBy: "Breakdown By {{type}}",
    progressPct: "Progress {{pct}}%",
    uncategorized: "Uncategorized",
    noGroup: "No Group",
    importResult: "Import Result",
    rowErrors: "Row errors",
    typeAdmin: "{{type}} Admin",
    orgTypeLabel: "Organisation Type",
    descriptionLabel: "Description",
    contactMobileNumber: "Contact Mobile Number",
    settingsDesc: "Manage your workspace profile, branding, and payout settlement accounts.",
    logoUploadDesc: "Upload your official logo to display across your portal header, campaigns, and receipts.",
    logoRecommendation: "Recommended: Square image (e.g. 500x500px). Formats: PNG, JPG, WebP up to 2MB.",
    exportCsvReport: "Export CSV Report",
    reportsAuditNote: "All financial reports are automatically audited and scoped to your organisation workspace.",
    memberCenter: "Member Center",
    verifyImportDesc: "Import and verify members, then send reminders by group or cohort.",
    uploadMemberList: "Upload Member List or Organization Data",
    requiredColumns: "Required columns: Name / Nama, Class / Kelas and Sports House / Rumah Sukan. Optional: Member ID, Gender, IC, Notes.",
    downloadSampleCsv: "Download Sample CSV",
    dragDrop: "Drag and drop your file here",
    orChooseFile: "or choose a file",
    chooseFile: "Choose File",
    uploadFile: "Upload File",
    sendOrderReminders: "Send Order Reminders",
    notifyContacts: "Notify contacts for members who have not ordered.",
    allGroups: "All Groups",
    sendReminders: "Send Reminders",
    orderedLabel: "Ordered",
    notOrderedLabel: "Not Ordered",
    progress: "Progress",
    verificationOverview: "Verification Overview",
    viewBy: "View By:",
    group: "Group",
    category: "Category",
    filterGroup: "Filter Group:",
    breakdownByGroup: "Breakdown by Group",
    memberDirectory: "Member Directory",
    nameHeader: "Name",
    ordersHeader: "Orders",
    parentHeader: "Parent",
    noMembersFound: "No members found",
    noMembersHint: "Try another group or import organization data to populate this directory.",
    orgLogo: "Organisation Logo",
    orgName: "Organisation / Club Name",
    addItem: "Add Item",
    addPayoutHint: "Click \"+ Add Payout Account\" above to submit your bank or PayPal account for payout settlements.",
    orgProfile: "Organisation Profile",
    orgCampaigns: "Organisation Campaigns",
    recentCampaigns: "Recent campaigns created by your organisation",
    recentOrders: "Recent Member Orders",
    recentOrdersDesc: "Latest member purchases and payments",
    dashSettings: "Organisation Settings",
    sending: "Sending...",
    schoolProfile: "School Profile",
    schoolLogo: "School Logo",
    changeLogo: "Change Logo",
    schoolName: "School Name",
    addPayoutAccount: "Add Payout Account",
    payoutDesc: "We require you to submit your payout account details for verification and payout settlement purposes.",
    primary: "Primary",
    currencyColon: "Currency:",
    addBankAccount: "Add Bank Account",
    bank: "Bank",
    accountNumber: "Account number",
    beneficiaryName: "Beneficiary name",
    idType: "ID Type",
    idNumber: "ID Number",
    currency: "Currency",
    addPaypal: "Add PayPal Account",
    paypalEmail: "PayPal Email",
    accountHolderName: "Account Holder Name",
    saving: "Saving...",
    back: "Back",
  },
  campaign: {
    searchCampaignsPh: "Search campaigns...",
    allStatus: "All Status",
    noCampaignsYet: "No campaigns yet",
    viewCampaign: "View campaign",
    previewCampaign: "Preview campaign",
    moreActions: "More actions",
    studentListRequired: "Student list required",
    scanQr: "Scan QR code to open campaign storefront",
    campaignDetails: "Campaign Details",
    orderCutoff: "Order Cut-off",
    paymentDue: "Payment Due",
    distributionDate: "Distribution Date",
    distributionMethod: "Distribution Method",
    collectionPoint: "Collection Point",
    allocation: "Allocation",
    quantityTarget: "Quantity Target",
    minMaxOrder: "Min / Max Order",
    noItems: "No items yet",
    noPayments: "No payments yet",
    qrPasses: "QR Passes",
    qrDesc: "QR codes are automatically generated after successful payment. One QR per order.",
    noQr: "No QR passes generated yet",
    noQrHint: "QR codes appear after orders are paid",
    productionDesc: "Track production status and batch processing here.",
    packingDesc: "Manage packing lists and batch packing operations here.",
    delivery: "Delivery / Collection",
    deliveryDesc: "Track deliveries, collections, and distribution here.",
    groupEventsDesc: "Group ordering events for your organization",
    createFirstDesc: "Create your first group ordering campaign",
    studentCsvHint: "Upload and validate your student CSV before submitting this campaign for approval.",
    sku: "SKU:",
    itemsCount: "Items ({{count}})",
    ordersCount: "Orders ({{count}})",
    orderHash: "Order #",
    duplicate: "Duplicate",
    totalItemsLabel: "Total Items",
  },

  school: {
    membersTitle: "Members",
    membersDesc: "Manage your school administrators and member directory.",
    searchMembersPh: "Search members...",
    reportsTitle: "Campaign Reports",
    reportsDesc: "Analyze ordering, payment, and delivery records in campaign context.",
    paidOrdersKpi: "Paid Orders",
    pendingOrdersKpi: "Pending Orders",
    studentsOrderedOfShort: "Students ordered / Total students",
    teacherRole: "Teacher",
    administratorRole: "Administrator",
    pendingSetup: "Pending Setup",
    noMembersFound: "No members found",
    uploadCsvHint: "Upload your student CSV to get started.",
    memberImportDesc: "Upload your member roster from a CSV file, or download the template to fill in first.",
    directoryDesc: "Directory of organisation members and registered accounts.",
    orgUploadCsvHint: "Upload your member CSV to get started.",
    statusActive: "active",
    fewerThanDb: "The uploaded CSV contains fewer {{members}} than your current database.",
    newMembersToImport: "New {{members}} to be imported:",
    previousReplaced: "Previous {{members}} replaced:",
    labelsReady: "{{count}} labels are ready for printing",
    allOrdered: "All students have ordered",
    readyForApproval: "Ready for approval",
    readyForApprovalDesc: "Student list validated. Submit this campaign for review.",
    awaitingApproval: "Awaiting approval",
    awaitingApprovalDesc: "{{name}} has been submitted and is pending Super Admin review.",
    approvedReady: "Approved — ready to publish",
    approvedReadyDesc: "{{name}} is approved. Publish to open ordering.",
    closingSoon: "Campaign closing soon",
    closingSoonDesc: "{{name}} closes in {{days}} days.",
    sendRemindersHint: "Send reminders to drive orders.",
    noDescription: "No description",
    reportSuffix: "Reports",
    dashTitle: "School operations overview.",
    setupComplete: "Setup Complete",
    campaignRunning: "Campaign Running",
    runningCampaign: "RUNNING CAMPAIGN",
    published: "Published",
    opened: "Opened:",
    closes: "Closes:",
    daysLeft: "({{days}}d left)",
    orderProgress: "Order Progress",
    studentsOrderedOf: "Students ordered / Total students:",
    studentsNeedOrder: "{{count}} students still need to order",
    viewCampaign: "View Campaign",
    sendReminders: "Send Reminders",
    campaignTimeline: "Campaign Timeline",
    tlCreated: "Created",
    tlSubmitted: "Submitted",
    tlApproved: "Approved",
    tlPublished: "Published",
    noActiveCampaignsDesc: "Create a campaign to start receiving orders.",
    otherCampaigns: "Other Campaigns",
    opensOn: "Opens {{date}}",
    ordersOpen: "Orders Open",
    distribution: "Distribution",
    kpiStudents: "STUDENTS",
    kpiParentsLinked: "PARENTS LINKED",
    kpiOrders: "ORDERS",
    kpiNotOrdered: "NOT ORDERED",
    actionRequired: "Action Required",
    studentsHaventOrdered: "{{count}} students haven't ordered",
    daysUntilClosing: "{{days}} days until closing ({{date}}).",
    recentOrders: "Recent Member Orders",
    viewAll: "View all",
    orderHeader: "ORDER",
    buyerHeader: "BUYER",
    classHeader: "CLASS",
    qtyHeader: "QTY",
    statusHeader: "STATUS",
    closesOn: "Closes {{date}}",
    itemsCount: "{{count}} items",
    viewAction: "View",
    schoolAdmins: "School Administrators",
    schoolAdminsDesc: "People who manage this school account.",
    addAdministrator: "Add Administrator",
    owner: "Owner",
    active: "Active",
    studentImport: "Student Import",
    studentImportDesc: "Upload your student roster from a CSV file, or download the template to fill in first.",
    lastImport: "LAST IMPORT",
    never: "Never",
    downloadCsvTemplate: "Download CSV Template",
    uploadCsv: "Upload CSV",
    schoolMembers: "School Members",
    schoolMembersDesc: "Students, parents and teachers. Members are created automatically through CSV import, parent claims, and teacher invitations.",
    totalKpi: "TOTAL",
    studentsKpi: "STUDENTS",
    inactiveKpi: "INACTIVE",
    filterStudents: "Students",
    filterInactive: "Inactive",
    exportCsv: "Export CSV",
    importCsv: "Import CSV",
    nameHeader: "Name",
    classDeptHeader: "CLASS / DEPT",
    sportsHouseHeader: "SPORTS HOUSE",
    parentLinkedHeader: "PARENT LINKED",
    actionsHeader: "ACTIONS",
    notLinked: "Not linked",
    linked: "Linked",
    showingMembers: "Showing {{from}}–{{to}} of {{total}} members",
    rowsPerPage: "Rows per page:",
    previous: "Previous",
    next: "Next",
    campaignLabel: "CAMPAIGN",
    overview: "OVERVIEW",
    totalEnrolled: "Total enrolled",
    acrossAllCampaigns: "Across all campaigns",
    paymentConfirmed: "Payment confirmed",
    awaitingPayment: "Awaiting payment",
    completionDelivery: "ORDER COMPLETION & DELIVERY",
    completionPct: "COMPLETION %",
    paidAmount: "PAID AMOUNT",
    collected: "Collected",
    inProduction: "IN PRODUCTION",
    beingMade: "Being made",
    packing: "PACKING",
    beingPacked: "Being packed",
    inDelivery: "IN DELIVERY",
    onTheWay: "On the way",
    completed: "COMPLETED",
    delivered: "Delivered",
    allStudents: "All Students",
    notLinkedLabel: "Not Linked",
    orderedLabel: "Ordered",
    pendingLabel: "Pending",
    studentNameHeader: "STUDENT NAME",
    parentStatusHeader: "PARENT STATUS",
    orderStatusHeader: "ORDER STATUS",
    lastOrderHeader: "LAST ORDER",
    notOrdered: "Not Ordered",
    showingStudents: "Showing {{from}}–{{to}} of {{total}} students",
    opsTitle: "Campaign Operations",
    opsDesc: "Orders, production, packing, and delivery are managed from campaign context.",
    printLabelDisabled: "Print label is disabled for this school. Contact Super Admin.",
    openLabelPrint: "Open Label Print Center",
    totalOrdersKpi: "TOTAL ORDERS",
    onlineKpi: "ONLINE",
    manualKpi: "MANUAL",
    printLabelsKpi: "PRINT LABELS",
    orgBadge: "ORGANIZATION",
    createAssistedOrder: "Create Assisted Order",
    assistedModeDesc: "Assisted checkout mode for offline buyers or assisted walk-in purchases.",
    selectProduct: "Select Product",
    noActiveProducts: "No active products are available for this organization",
    memberNameWith: "{{member}} Name",
    saveOrder: "Save Order",
    orderQueue: "Order Queue",
    showingOf: "Showing {{shown}} of {{total}} orders in current filters",
    searchOrderPh: "Search order, buyer, class, size, amount",
    allStatus: "All Status",
    paidOnline: "Paid Online",
    allTypes: "All Types",
    allOrders: "All",
    pickHeader: "Pick",
    selectAllOrders: "Select all orders ({{count}})",
    groupLabel: "Group",
    awaitingApprovalStatus: "Awaiting Approval",
    labelsReady: "{{count}} labels are ready for printing",
    teacherRole: "Teacher",
    administratorRole: "Administrator",
    pendingSetup: "Pending Setup",
    searchMembersPh: "Search members...",
    noMembersFound: "No members found",
    uploadCsvHint: "Upload your student CSV to get started.",
    memberImportDesc: "Upload your member roster from a CSV file, or download the template to fill in first.",
    directoryDesc: "Directory of organisation members and registered accounts.",
    orgUploadCsvHint: "Upload your member CSV to get started.",
    statusActive: "active",
    fewerThanDb: "The uploaded CSV contains fewer {{members}} than your current database.",
    newMembersToImport: "New {{members}} to be imported:",
    previousReplaced: "Previous {{members}} replaced:",
    lastImportLabel: "Last import:",
    noStudentsImported: "No students imported yet.",
    paidOrdersKpi: "Paid Orders",
    pendingOrdersKpi: "Pending Orders",
    studentsOrderedOfShort: "Students ordered / Total students",
    studentNameHeader2: "Student Name",
    sportsHouseHeader2: "Sports House",
    termStudent: "Student",
    termClass: "Class",
    termClasses: "Classes",
    termParentOnline: "Parent Online",
    termAdminAssisted: "Admin Assisted",
    termMember: "Member",
    termOnlineBuyer: "Online Buyer",
    termCommittee: "Committee",
    termDepartment: "Department",
    termGroup: "Group",
    termTeam: "Team",
    termEmployee: "Employee",
    termVolunteer: "Volunteer",

    phoneNumber: "Phone Number",
    address: "Address",
    size: "Size",
    quantity: "Quantity",
    stockSuffix: "{{size}} ({{stock}} stock)",
    orderHeader2: "Order",
    buyerHeader2: "Buyer",
    qtyHeader2: "Qty",
    amountHeader: "Amount",
    typeHeader: "Type",
    classLabel: "Class",
    studentName: "Student Name",
    membersKpi: "Members",

    paymentMethod2: "Payment Method",
    manualPaymentReview: "Manual Payment Review",
    schoolPaymentApproval: "School Payment Approval",
    orgPaymentConfirmation: "Organization Payment Confirmation",
    printLabels2: "Print Labels",
    queueFirstWorkflow: "Queue-first workflow: select records, preview PDF, then confirm print for audit logging.",
    manualVerified: "Manual Verified",
    pending2: "Pending",
    pageOf: "Page {{page}} of {{total}}",
    type2: "Type",
    name2: "Name",
    adminsTitle: "School Administrators",
    campaign2: "Campaign",
    overview2: "Overview",

    statusActiveLabel: "Active",

    kpiParents: "Parents",
    kpiEmployees: "Employees",
    kpiParticipants: "Participants",
    kpiVolunteers: "Volunteers",

    complimentary: "Complimentary",
    notes: "Notes",

  },
  term: {
    organization: "Organization",
    school: "School",
    company: "Company",
    club: "Club",
    university: "University",
    member: "Member",
    employee: "Employee",
    student: "Student",
    memberLower: "member",
    employeeLower: "employee",
    studentLower: "student",
    group: "Group",
    class: "Class",
    department: "Department",
    committee: "Committee",
    faculty: "Faculty",
    groupLower: "group",
    classLower: "class",
    departmentLower: "department",
    committeeLower: "committee",
    facultyLower: "faculty",
    groupPlaceholderClass: "e.g. 1A",
    groupPlaceholderTeam: "e.g. Sales Team",
    groupPlaceholderCommittee: "e.g. Events Committee",
    groupPlaceholderFaculty: "e.g. Faculty of Engineering",
    groupPlaceholderGeneric: "e.g. Group A",
  },
  campaignForm: {
    createCampaign: "Create Campaign",
    editCampaign: "Edit Campaign",
    campaignApproved: "Campaign (Approved)",
    blueprintSubtitle: "Choose a blueprint to get started quickly",
    formSubtitle: "Set up your group ordering event",
    chooseBlueprint: "Choose a Blueprint",
    chooseBlueprintDesc: "Select a template to auto-configure your campaign. You can still change everything later.",
    orBlankCampaign: "Or start with a blank campaign",
    fromLabel: "From",
    usingBlueprint: "Using blueprint: {{label}}",
    change: "Change",
    bpBlank: "Blank Campaign",
    bpBlankDesc: "Start from scratch with default settings.",
    bpSportsWear: "Sports Wear & Athletic Apparel",
    bpSportsWearDesc: "T-shirts, jerseys, and sports day attire with size variations.",
    bpUniform: "Uniform & Official Gear",
    bpUniformDesc: "Standard uniform sets and official gear with standard sizing.",
    bpMarathon: "Marathon / Fun Run",
    bpMarathonDesc: "Race bibs, finisher shirts, and event merchandise.",
    bpProductSale: "Product Sale",
    bpProductSaleDesc: "General product sales with inventory tracking.",
    bpTicketing: "Ticketing",
    bpTicketingDesc: "Event tickets with tiered pricing and QR collection.",
    bpDonation: "Donation",
    bpDonationDesc: "Fundraising with complimentary payment and open access.",
    bpMembership: "Membership",
    bpMembershipDesc: "Club or association memberships with member verification.",
    bpService: "Service Booking",
    bpServiceDesc: "Book services or appointments with time slots.",
    bpProperty: "Property Roadshow",
    bpPropertyDesc: "Property listings and open house registrations.",
    bpVehicle: "Vehicle Promotion",
    bpVehicleDesc: "Vehicle sales, test drives, and promotion campaigns.",
    bpSportsWearName: "Annual Sports Day & Athletic Apparel Drive",
    bpSportsWearDesc2: "Official team jerseys, sports t-shirts, and athletic gear with size options.",
    bpUniformName: "Official Uniform & Apparel Set 2026",
    bpUniformDesc2: "Standard uniform sets, shirts, and official apparel with standard sizing.",
    bpMarathonName: "Annual Marathon & Fun Run 2026",
    bpMarathonDesc2: "Race bibs, event t-shirts, finisher medals, and fun run registration.",
    bpProductSaleName: "Exclusive Official Merchandise & Product Sale",
    bpProductSaleDesc2: "Official club merchandise, apparel, accessories, and promotional items.",
    bpTicketingName: "Annual Gala Dinner & Event Ticketing",
    bpTicketingDesc2: "Event tickets, concert passes, and admission entry with QR pass verification.",
    bpDonationName: "Community & Charity Fundraising Campaign",
    bpDonationDesc2: "Fundraising drive for charity initiatives, community projects, and voluntary donations.",
    bpMembershipName: "Annual Organization Membership Registration 2026",
    bpMembershipDesc2: "Club, association, or community annual membership dues and member registration.",
    bpServiceName: "Professional Service & Appointment Booking",
    bpServiceDesc2: "Book appointments, coaching sessions, or facility time slots with scheduled reservations.",
    bpPropertyName: "Exclusive Property Roadshow & Open House Event",
    bpPropertyDesc2: "VIP open house registration, unit viewing appointments, and roadshow booking.",
    bpVehicleName: "New Vehicle Launch & Test Drive Promotion",
    bpVehicleDesc2: "Book test drive slots, reserve promotional offers, and lock special launch pricing.",
    lockedBanner: "This campaign is {{status}}. Direct editing is locked.",
    lockedSubtitle: "This campaign is approved and locked. Submit a change request to propose edits.",
    lockedDesc: "To change pricing, products, stock, variations, dates, or images, submit a change request for Super Admin review. The live campaign stays unchanged until approved.",
    pendingRequest: "A change request is pending review",
    reasonLabel: "Reason: {{reason}}",
    submittedStatus: "Submitted {{date}} · Status: {{status}}",
    cancelRequest: "Cancel request",
    requestChange: "Request Change",
    submitChangeRequest: "Submit Change Request",
    changeRequestDesc: "Make your changes in the form below, then explain why. The live campaign won't change until a Super Admin approves.",
    changeReasonPh: "e.g., Need to add size M and adjust price for the approved campaign",
    submitting: "Submitting...",
    submitRequest: "Submit Request",
    campaignInfo: "Campaign Information",
    required: "Required",
    campaignName: "Campaign Name",
    campaignNamePh: "e.g., Sports Day 2026",
    campaignType: "Campaign Type",
    selectType: "Select type...",
    basePrice: "Base Price",
    basePriceError: "Base price is required and must be greater than RM 0.00",
    skuLabel: "SKU",
    skuPh: "e.g., SD2026-TS",
    sleeveType: "Sleeve Type",
    shortSleevePrice: "Short Sleeve Price (RM)",
    longSleevePrice: "Long Sleeve Price (RM)",
    ticketingTitle: "Event & Ticket Configuration",
    ticketingPreset: "Ticketing Preset",
    venueLabel: "Event Venue / Location",
    venuePh: "e.g., Grand Ballroom / Online Stream",
    tierLabel: "Ticket Category / Tier",
    tierPh: "e.g., VIP Admission Pass / General Entry",
    ticketingNote: "Automated QR digital pass redemption enabled for ticket holders upon confirmation.",
    donationTitle: "Fundraising & Contribution Setup",
    donationPreset: "Donation Preset",
    causeLabel: "Beneficiary Cause / Project Goal",
    causePh: "e.g., Community Library Fund & Equipment Purchase",
    donationNote: "Donation receipt notification and voluntary payment policy active.",
    membershipTitle: "Membership Tier & Benefit Setup",
    membershipPreset: "Membership Preset",
    tierNameLabel: "Membership Tier Name",
    tierNamePh: "e.g., Annual Gold Member Pass",
    validityLabel: "Validity Period",
    validityPh: "e.g., 1 Year (Jan 2026 - Dec 2026)",
    serviceTitle: "Service & Slot Reservation Setup",
    servicePreset: "Service Preset",
    durationLabel: "Session Duration",
    durationPh: "e.g., 60 Minutes per session",
    locationLabel: "Location / Venue",
    locationPh: "e.g., Main Studio & Appointment Center",
    propertyTitle: "Property Launch & Roadshow Setup",
    propertyPreset: "Property Preset",
    venueLabel2: "Roadshow Venue / Sales Gallery",
    venuePh2: "e.g., Central Convention Center & Sales Gallery",
    unitLabel: "Featured Unit Category",
    unitPh: "e.g., Luxury Condominium & Executive Suites",
    vehicleTitle: "Vehicle Launch & Test Drive Setup",
    vehiclePreset: "Vehicle Preset",
    showroomLabel: "Showroom / Test Drive Location",
    showroomPh: "e.g., Flagship Showroom & Test Track",
    modelLabel: "Vehicle Model / Edition",
    modelPh: "e.g., 2026 Sport Performance Edition",
    sizeVariations: "Size & Variations",
    sizeVariationsHint: "Enable the sizes you offer. Use Price Override to set a different price for larger sizes (e.g., 3XL, 4XL, 5XL). Leave blank to use the sleeve base price.",
    sizeHeader: "Size",
    enabledHeader: "Enabled",
    priceOverrideHeader: "Price Override (RM)",
    skuHeader: "SKU",
    priceLabel: "Price:",
    setBasePrice: "Set base price",
    sizesLabel: "Sizes:",
    campaignDetails: "Campaign Details",
    campaignCover: "Campaign Cover",
    coverDesc: "Hero banner for the public campaign preview. Marketing / branding image — not a product image.",
    noCoverYet: "No cover yet — the school's default banner or the Cheeco banner will be shown on the public page.",
    coverPoster: "Cover Poster",
    productImage: "Product Image",
    productImageHint: "(required before submit)",
    productImageDesc: "Upload the actual clothing/product photo. This image is shown to parents on the campaign page and in their cart.",
    productImageRequired: "A product image is required before you can submit this campaign.",
    shortDescription: "Short Description",
    shortDescriptionPh: "Describe what this campaign is about...",
    orderCutoff: "Order Cut-off",
    orderCutoffPh: "Select cut-off date & time",
    paymentDue: "Payment Due",
    paymentDuePh: "Select due date & time",
    distributionDate: "Distribution / Collection Date",
    distributionDatePh: "Select distribution date & time",
    visibility: "Visibility",
    buyerAccessMode: "Buyer Access Mode",
    buyerAccessDesc: "Choose whether this campaign is restricted to Organisation Members or open to the public.",
    membersOnly: "🔒 Members Only",
    membersOnlyDesc: "Only approved Organisation Members can view and purchase.",
    publicOpen: "🌐 Public (Open to All)",
    publicOpenDesc: "Anyone with the link or QR code can purchase directly without joining.",
    paymentSettings: "Payment Settings",
    defaultPaymentMethod: "Default Payment Method",
    defaultAllocationMethod: "Default Allocation Method",
    distributionTitle: "Distribution",
    distributionMethod: "Distribution Method",
    collectionPoint: "Collection Point / Venue",
    collectionPointPh: "e.g., {{default}}",
    sportsHouseConfig: "Sports House Configuration",
    sportsHouseDesc: "Group students into sports houses so each jersey variation shows the correct house colours and crest.",
    assignmentMethod: "Assignment Method",
    useCsv: "Use Student CSV",
    parentSelect: "Parent Select During Checkout",
    noHouse: "No Sports House",
    recommended: "Recommended",
    recommendedDesc: "Recommended — matches official records",
    csvHelpText: "Student CSV reads the student's Rumah Sukan from the imported member roster and assigns it automatically. Parents cannot change it.",
    sportsHouses: "Sports Houses",
    addHouse: "+ Add House",
    noHousesYet: "No houses added yet. Add the houses (e.g. Red, Blue, Green, Yellow).",
    housePh: "e.g., Red House",
    houseColour: "House colour",
    removeHouse: "Remove house",
    parentsChoose: "Parents will choose one of these houses during checkout.",
    quantitySettings: "Quantity Settings",
    quantityTarget: "Quantity Target",
    minOrderQty: "Min Order Qty",
    maxOrderQty: "Max Order Qty",
    saveDraft: "Save as Draft",
    publishing: "Publishing...",
    publish: "Publish",
    saveContinue: "Save & Continue",
    visOrgOnly: "Organization Only",
    visPublic: "Public",
    visPrivate: "Private (Invitation Only)",
    pmOnline: "Online Payment",
    pmManual: "Manual Payment",
    pmFunding: "Funding / Sponsored",
    pmComplimentary: "Complimentary (FOC)",
    allocOpen: "Open Access",
    allocCodes: "Campaign Codes",
    allocManual: "Manual Approval",
    distCollection: "Collection",
    distDelivery: "Delivery",
    distBoth: "Both",
    errLoadCampaign: "Failed to load campaign",
    errUploadPoster: "Failed to upload poster",
    errNameRequired: "Campaign name is required",
    errBasePriceRequired: "Base price is required before publishing",
    errSizeRequired: "At least one size must be enabled before publishing",
    errOpeningRequired: "Opening date is required before publishing",
    errClosingRequired: "Closing date is required before publishing",
    errClosingAfterOpening: "Closing date must be after opening date",
    errHouseRequired: "Add at least one sports house before publishing",
    errSave: "Failed to save campaign",
    errPublish: "Failed to publish campaign",
    errChangeReason: "Please provide a reason for the change request (at least 3 characters).",
    errSubmitChange: "Failed to submit change request",
    confirmCancelChange: "Cancel this change request? The campaign will remain unchanged.",
    errCancelChange: "Failed to cancel change request",
    useCampaignDefault: "Use Campaign Default",
    autoAlloc: "Automatic",
    codeRequired: "Code Required",
    editItem: "Edit Item",
    addItem: "Add Item",
    whatIsAvailable: "What is available to order?",
    itemInfo: "Item Information",
    itemName: "Item Name",
    itemNamePh: "e.g., Sports Shirt",
    itemImage: "Item Image",
    houseJerseyImages: "Sports House Jersey Images",
    houseJerseyDesc: "Upload a separate jersey image for each house so parents see the correct house colours at checkout.",
    houseJerseyImage: "House Jersey Image",
    descLabel: "Description",
    descPh: "Describe the item...",
    sellingPrice: "Selling Price",
    unlimited: "Unlimited",
    limited: "Limited",
    availableQtyPh: "Available quantity",
    optionsOptional: "Options (Optional)",
    optionsDesc: "Add simple options like Size, Colour, Gender. System will auto-generate all combinations.",
    optionNamePh: "Option name (e.g., Size)",
    optionValuesPh: "Values (one per line or comma separated)",
    addOption: "Add Option",
    paymentOverride: "Payment Override (Optional)",
    paymentOverrideDesc: "Override campaign defaults for this item, or leave blank to use campaign settings.",
    itemPaymentMethod: "Payment Method",
    allocationMethodLabel: "Allocation Method",
    updateItem: "Update Item",
    saveItem: "Save Item",
    errLoadItem: "Failed to load item",
    errUploadImage: "Failed to upload image",
    errUploadHouseImage: "Failed to upload house image",
    errItemNameRequired: "Item name is required",
    errSellingPrice: "Selling price is required",
    errQtyRequired: "Available quantity is required when not unlimited",
    errSaveItem: "Failed to save item",
    ticketTiers: "Ticket Tiers",
    addTicketTier: "+ Add Ticket Tier",
    tierName: "Tier Name",
    tierPrice: "Price (RM)",
    tierCapacity: "Capacity / Quantity",
    tierSku: "SKU",
    removeTier: "Remove",
    tierNameRequired: "Tier name is required.",
    tierDuplicateName: "Tier names must be unique within the campaign.",
    tierPriceRequired: "Tier price is required and must be greater than 0.",
    tierCapacityRequired: "Tier capacity is required and must be greater than 0.",
    tierSkuDuplicate: "Tier SKU must be unique within the campaign.",
    atLeastOneTier: "At least one ticket tier is required.",
    tiersHint: "Each tier is an independently purchasable ticket with its own price and capacity.",
    tiersLabel: "Tiers:",
    capacityLeft: "{{n}} left",
    selectTierPh: "Choose a tier to see its price.",
    errInvalidFormat: "Invalid format: {{type}}. Only JPG, PNG, and WebP are accepted.",
    errFileTooLarge: "File too large: {{size}}. Maximum is {{max}} MB.",
    errImageRatio: "Image ratio is {{ratio}} but recommended is {{recommended}} ({{label}}). The image may be cropped or displayed incorrectly.",
    recommended2: "Recommended: {{ratio}}",
    uploading: "Uploading...",
    clickToUpload: "Click to upload or drag and drop",
    uploadFormats: "JPG, PNG, WebP up to {{max}} MB",
    previewAlt: "Preview",
    removeImage: "Remove image",
    webpNotice: "Image will be automatically converted to WebP and optimized for web delivery.",
    selectDate: "Select date",
    ratioCover: "Campaign Cover",
    ratioProduct: "Product / Logo",
    ratioGallery: "Gallery / Lifestyle",
    prevYear: "Previous Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    nextYear: "Next Year",
    timeLabel: "Time",
    today: "Today",
    done: "Done",
  },
};

export default en;
